import { React, useState } from 'react';
import styles from './Navbar.module.css';
import Logo from "../../images/AvisLogo.png"
import {
  // AiOutlineUser,
  // AiOutlineSearch,
  AiOutlineMenu,
  AiOutlineClose,
} from 'react-icons/ai';
import { NavLink } from 'react-router-dom';

const Navbar = () => {
  const [nav, setNav] = useState(false);

  const navLinkStyles = ({ isActive }) => {
    return {
      fontWeight: isActive ? 'bold' : 'normal',
    }
  }

  return (
    <header className={styles.navbar}>
      <NavLink className={styles.logo} to='/'><img src={Logo} alt='Logo' /></NavLink>
      <nav>
        <ul className={nav ? [styles.menu, styles.active].join(' ') : [styles.menu]} >

          <li>
            <NavLink style={navLinkStyles} to='/reservation'><a href='/#'>RESERVATIONS</a></NavLink>
          </li>

          <li>
            <NavLink style={navLinkStyles} to='/cars'><a href='/#'>CARS</a></NavLink>
          </li>

          {/* <li>
            <NavLink style={navLinkStyles} to='/Satesto'><a href='/#'>Satesto</a></NavLink>
          </li> */}

          

          
          
          {/* <li>
            <AiOutlineSearch size={25} style={{ marginTop: '6px' }} />
          </li>

          <li>
            <AiOutlineUser size={25} style={{ marginTop: '6px' }} />
          </li> */}
        </ul>
      </nav>
      <div onClick={() => setNav(!nav)} className={styles.mobile_btn}>
        {nav ? <AiOutlineClose size={30} /> : <AiOutlineMenu size={30} />}

      </div>
    </header>
  );
};

export default Navbar;





